// **********************************************************
// locations
// **********************************************************

const locations = document.querySelectorAll('[data-slider="locations-slider"]');

const locationsOptions = {
  slidesPerView: 1,
  spaceBetween: 12,
  speed: 800,
  breakpoints: {
    767: {
      slidesPerView: 'auto',
      spaceBetween: 25,
    },
    1023: {
      slidesPerView: 'auto',
      spaceBetween: 30,
    },
    1199: {
      slidesPerView: 'auto',
      spaceBetween: 40,
    },
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
};

locations.forEach((el) => {
  const locationsEle = el.closest('.locations');

  const arrowRight = locationsEle.querySelector('.arrow-right');
  const arrowLeft = locationsEle.querySelector('.arrow-left');

  locationsOptions.navigation.nextEl = arrowRight;
  locationsOptions.navigation.prevEl = arrowLeft;

  new Swiper(el, locationsOptions);
});

// **********************************************************
// Open Content Modal
// **********************************************************

const openModal = (triggerElement) => {
  const modal = document.querySelector(`[data-modal="${triggerElement.dataset.triggerModal}"]`);

  if (modal) {
    modal.classList.add('is-open-modal');
    toggleBodyScrollLock(true);
  }
};

document.querySelectorAll('.locations__item').forEach((item) => {
  item.addEventListener('click', (ev) => {
    const parentEle = ev.target.closest('[data-trigger-modal]');

    if (parentEle) {
      openModal(parentEle);
      ev.preventDefault();
    }
  });
});
